import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  currentText: string | null = null;

  constructor(private spinner: NgxSpinnerService) {}

  show(text?: string): void {
    this.currentText = text || null;
    this.spinner.show();
  }

  hide(): void {
    this.spinner.hide();
    this.currentText = null; // Reset the text when hiding the spinner
  }

  getText(): string | null {
    return this.currentText;
  }
}